export default function (props) {
    return (
        <>
            <div className="landing-template-title">{props.title}</div>
            <div className="landing-template-sub-title">{props.subTitle}</div>
        </>
    );
}
